import { memo, useMemo } from 'react';
import { motion } from 'framer-motion';
import type { ElementType } from 'react';
import { cn } from '@/lib/utils';
import {
  shimmerTextClassName,
  useShimmerMotion,
  type ShimmerHighlight,
} from '@/components/ui/use-shimmer-motion';

export interface ShimmerProps {
  children: string;
  as?: ElementType;
  className?: string;
  duration?: number;
  spread?: number;
  delay?: number;
  highlight?: ShimmerHighlight;
}

const ShimmerComponent = ({
  children,
  as: Component = 'p',
  className,
  duration = 2,
  spread = 2,
  delay = 0,
  highlight = 'default',
}: ShimmerProps) => {
  const MotionComponent = useMemo(
    () => motion(Component as keyof React.JSX.IntrinsicElements),
    [Component],
  );

  const { style, initial, animate, transition } = useShimmerMotion({
    textLength: children.length,
    duration,
    spread,
    delay,
    highlight,
  });

  return (
    <MotionComponent
      initial={initial}
      animate={animate}
      transition={transition}
      className={cn(shimmerTextClassName, className)}
      style={style}
    >
      {children}
    </MotionComponent>
  );
};

export const Shimmer = memo(ShimmerComponent);
